/**
 * @generated SignedSource<<bf18d931623c9857e39c76c295fb0def>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SbRespRefineMenuFilterCaratWeight_itemSearch$data = {
  readonly " $fragmentSpreads": FragmentRefs<"SbSharedRefineMenuCaratWeight_itemSearch">;
  readonly " $fragmentType": "SbRespRefineMenuFilterCaratWeight_itemSearch";
};
export type SbRespRefineMenuFilterCaratWeight_itemSearch$key = {
  readonly " $data"?: SbRespRefineMenuFilterCaratWeight_itemSearch$data;
  readonly " $fragmentSpreads": FragmentRefs<"SbRespRefineMenuFilterCaratWeight_itemSearch">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbRespRefineMenuFilterCaratWeight_itemSearch",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuCaratWeight_itemSearch"
    }
  ],
  "type": "ItemSearchQueryConnection",
  "abstractKey": null
};

(node as any).hash = "e1a176908cb88e74c5bfbd6093c521da";

export default node;
